import { render, staticRenderFns } from "./AuthoritySetting.vue?vue&type=template&id=37556d90&scoped=true&"
import script from "./AuthoritySetting.vue?vue&type=script&lang=js&"
export * from "./AuthoritySetting.vue?vue&type=script&lang=js&"
import style0 from "./AuthoritySetting.vue?vue&type=style&index=0&id=37556d90&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37556d90",
  null
  
)

export default component.exports